export default {"src":"/_next/static/media/ic-gold-cup.e8ecdd1a.svg","height":130,"width":123};